import React from 'react';
import styled from '@emotion/styled';
import { Timeline } from '@mui/lab';
import { selectJobCreatedAt, selectJobTimeline } from '@/redux/selectors/jobSelectors';
import { TaskMilestone } from '@/redux/slices/slice_types';
import JobMilestone from './JobMilestone';
import { Grow } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';

const JobTimeline = () => {
  const jobTimeline = useAppSelector(selectJobTimeline);
  const jobCreatedAt = useAppSelector(selectJobCreatedAt);
  const firstPendingIndex = jobTimeline.findIndex((milestone: TaskMilestone) => milestone.task?.status === 'in_progress' || !milestone.completed_at);

  return (
    <JobTimelineContainer position="left">
      {jobTimeline.map((milestone: TaskMilestone, index: number) => (
        <Grow in key={milestone.name} timeout={(index + 1) * 200} style={{ transformOrigin: 'top center' }}>
          <div>
            <JobMilestone
              key={milestone.name}
              milestone={milestone}
              isFirstPending={index === firstPendingIndex}
              isLast={index === jobTimeline.length - 1}
              prevMilestone={jobTimeline[index - 1]}
              jobCreatedAt={jobCreatedAt}
            />
          </div>
        </Grow>
      ))}
    </JobTimelineContainer>
  );
};

export default React.memo(JobTimeline);

const JobTimelineContainer = styled(Timeline)`
  ${({ theme }) => theme.customOverrides?.JobTimeline}
  padding: 0;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;
